import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';

export type requestOpt = {
  endpoint: string,
  body?: any,
  params?: {
    [key: string]: string
  }
};

@Injectable({
  providedIn: 'root'
})
export class JdfRequestService {

  baseUrl: string = null;
  options = new RequestOptions({
    headers: new Headers({
      'Content-Type': 'application/json; charset=utf-8',
    })
  });

  constructor(
    public http?: Http,
  ) { }

  setBaseUrl(url: string) {
    this.baseUrl = url;
  }

  async get(options: requestOpt) {
    let url = this.baseUrl + `/${options.endpoint}`;

    if (options.params != undefined)
      url = `${url}/?${
        Object.keys(options.params)
          .map(v => (options.params[v] == undefined) ? '' : `${v}=${options.params[v]}`)
          .filter(v => v.length != 0)
          .join('&')
      }`;
    return new Promise(resolve => {
      this.http.get(url, this.options).toPromise().then(res => {
        resolve(res.json());
      });
    });
  }

  async post(options: requestOpt) {
    let url = this.baseUrl + `/${options.endpoint}`;

    if (options.params != undefined)
      url = `${url}/?${
        Object.keys(options.params)
          .map(v => (options.params[v] == undefined) ? '' : `${v}=${options.params[v]}`)
          .filter(v => v.length != 0)
          .join('&')
      }`;
    return new Promise(resolve => {
      this.http.post(url, options.body, this.options).toPromise().then(res => {
        resolve(res.json());
      });
    });
  }

  sayHello() {
    console.log("Hello from request !");
  }
}